module.exports = __webpack_public_path__ + "img/fossil2Img1.22386846.jpg";